import { decimalMinutesToFormattedTime } from '../../shared/chart-options';

export function ScoreChartTooltip({
  data: [totalMinutes, points],
  color,
  seriesName,
}) {
  const fmtMinutes = decimalMinutesToFormattedTime(totalMinutes);

  return `
    <div class="chart-tooltip chart-tooltip--center">
      <table>
        <thead><tr><th style="color: ${color}" class="cell-center">${seriesName}</th></tr></thead>
        <tbody>
          <tr>
            <td class="cell-center">${fmtMinutes}</td>
          </tr>
          <tr>
            <td class="cell-center">${points} points</td>
          </tr>
        </tbody>
      </table>
    </div>
  `;
}
